import Singleton from '../Singleton';
import ApiService from '../_shared/api/apiService';
import COUNTRY_CODES from '../_shared/types/countryCodes';

export default class FeatureFlagService extends Singleton<FeatureFlagService> {
  /**
   * Make API call to fetch feature flags
   */
  public getFeatureFlags = async (userId: number) => {
    if (!userId) {
      return {};
    }

    const client = await ApiService();

    const featureFlagsResponse = await client.apis[
      'feature-flag'
    ].retrieveAllFeatureFlags({
      userId,
      countryId: COUNTRY_CODES.CA
    });
    const featureFlags = featureFlagsResponse?.body;
    return featureFlags;
  };
}
